import {logger} from 'yougile-util'
import {DataObjectId} from 'yougile-model'
import {showPrompt} from '@components/common/base/notifications'
import {Backend} from '../../common/backend'
import {PageService} from './page-service'

export class LoginFromUrl {
  private static initializedAlready = false

  public static init(): void {
    const path = location.pathname ?? ''
    const pagePath = path.startsWith('/team/')
      ? path.replace('/team', '')
      : path

    if (pagePath?.startsWith('/login/')) {
      const data = pagePath.split('/login/')[1]
      const cred = atob(data)
      if (data && cred && cred.split('||').length === 3) {
        const userId = cred.split('||')[0] as DataObjectId
        const key = cred.split('||')[1]
        const path = decodeURIComponent(cred.split('||')[2])
        logger.log('Login', userId, path)
        Backend.setCredentials(userId, key)
        PageService.setPath(path)
        location.href = `/team${path}${location.search}#${location.hash}`
      } else {
        location.href = `/team/${location.search}#${location.hash}`
      }
    }

    if (this.initializedAlready) {
      return
    }
    this.initializedAlready = true

    document.addEventListener('keyup', async e => {
      if (e.ctrlKey && e.altKey && e.code === 'KeyY') {
        const key = btoa(
          Backend.loadId() +
            '||' +
            Backend.loadKey() +
            '||' +
            encodeURIComponent(PageService.getPath())
        )
        await showPrompt(
          'Link to login',
          location.protocol + '//' + location.host + '/team/login/' + key
        )
      }
    })
  }
}
